import { Provider } from 'react-redux';
import { AppProps } from 'next/app';
import appWithI18n from 'next-translate/appWithI18n';
import { FunctionComponent, useEffect, useState } from 'react';
import { withUnleashProvider } from 'next-unleash';
import { PLAYER_THEMES } from 'src/interfaces/enums';
import configureStore from '../store/config';
import i18nConfig from '../../i18n';
import 'intl-pluralrules';
import ErrorBoundary from '../components/ErrorBoundary';

const store = configureStore();

interface ICustomAppProps extends AppProps {
  err?: unknown;
}

const App = ({ Component, pageProps, err }: ICustomAppProps) => {
  const [stylesLoaded, setStylesLoaded] = useState(false);

  useEffect(() => {
    const handleLoadStyles = async () => {
      if (pageProps?.theme === PLAYER_THEMES.COSMOS) await import('../styles/cosmos.scss');
      else await import('../styles/globals.scss');

      setStylesLoaded(true);
    };

    handleLoadStyles();
  }, [pageProps]);

  if (!stylesLoaded) return false;

  return (
    <ErrorBoundary>
      <Provider store={store}>
        <Component {...pageProps} err={err} />
      </Provider>
    </ErrorBoundary>
  );
};

export default appWithI18n(withUnleashProvider(App) as FunctionComponent, {
  ...i18nConfig,
  // Set to false if you want to load all the namespaces on _app.js getInitialProps
  skipInitialProps: false,
});
